<div
  class="radio-group"
  [class.radio-group--full-width]="fullWidth"
  role="group"
>
  @for (opt of options; track opt.value) {
    <label [ngClass]="getBoxClasses(opt)" (click)="onToggle(opt)">

      <!-- ── 1. Cercle radio — toujours en premier ─────────────── -->
      <span class="radio-box__control">
        <span class="radio-box__inner"></span>
      </span>

      <!-- ── 2. Icône gauche (entre cercle et label) ───────────── -->
      @if (getIconPos(opt) === 'left') {
        <span class="radio-box__icon">
          <ng-container *ngTemplateOutlet="getIcon(opt.value)"></ng-container>
        </span>
      }

      <!-- ── 3. Label ──────────────────────────────────────────── -->
      <span class="radio-box__label">{{ opt.label }}</span>

      <!-- ── 4. Icône droite (après label) ────────────────────── -->
      @if (getIconPos(opt) === 'right') {
        <span class="radio-box__icon">
          <ng-container *ngTemplateOutlet="getIcon(opt.value)"></ng-container>
        </span>
      }

    </label>
  }
</div>

<!-- Message d'erreur — aligné sur input.component -->
@if (showError) {
  <span class="radio-error" role="alert">
    {{ errorMessage }}
  </span>
}